// extracted by mini-css-extract-plugin
module.exports = {"button":"modalCustom_button__2FxR8","wrapper":"modalCustom_wrapper__3gb8u","typography":"modalCustom_typography__2u2gs"};